var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconGlobe = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", stroke: props.color, strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", { transform: "translate(-1.083 -1.083)" },
                React.createElement("path", { d: "M26.9,16.1c0,6-4.9,10.8-10.8,10.8S5.3,22.1,5.3,16.1S10.1,5.3,16.1,5.3S26.9,10.1,26.9,16.1\n\t\tL26.9,16.1z" }),
                React.createElement("path", { d: "M5.3,16.1h21.7" }),
                React.createElement("path", { d: "M16.1,5.3c2.7,3,4.2,6.8,4.3,10.8c-0.1,4-1.6,7.9-4.3,10.8c-2.7-3-4.2-6.8-4.3-10.8\n\t\tC11.8,12.1,13.4,8.2,16.1,5.3z" })))));
});
export default IconGlobe;
//# sourceMappingURL=IconGlobe.js.map